export enum CommunicationCategory {
  TRANSACTIONAL = 'transactional',
  INITIATIVE = 'initiative'
}

export enum CommunicationChannel {
  EMAIL = 'email',
  PUSH = 'push',
  SMS = 'sms'
}

export interface CommunicationPreferenceItem {
  category: CommunicationCategory;
  channel: CommunicationChannel;
  isEnabled: boolean;
}

export interface GetCommunicationPreferencesResponse {
  status: 'success' | 'error';
  data: {
    preferences: CommunicationPreferenceItem[];
  };
  message?: string;
}

export interface UpdateCommunicationPreferencesRequest {
  preferences: CommunicationPreferenceItem[];
}

